// extracted by mini-css-extract-plugin
module.exports = {"postActionFeedWrapper":"PostActionFeed_postActionFeedWrapper_1VSWT"};